import { FC, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useI18n from "../../hooks/useTranslations";
import { useItemsApi } from "../../http/useItems";
import Button from "../ui/Button";
import FlexContent from "../ui/FlexContent";
import Header from "../ui/Header";
import SubmitBar from "../ui/SubmitBar";
import ItemPage from "./ItemPage";

const Item: FC = () => {
  const i18n = useI18n();
  const { itemId } = useParams<{ itemId: string }>();
  const aborter = useRef(new AbortController());
  const itemsApi = useItemsApi();
  const navigate = useNavigate();

  const { error, data, trigger } = itemsApi.getItem(aborter.current.signal);

  useEffect(() => {
    itemId && trigger(itemId);
  }, [itemId]);

  return (
    <>
      <Header
        title={data?.code ?? i18n.translation.common.loading}
        // TODO add "Edit item" button if the user has admin roles (or edit-item-permission)
        error={error}
        path={[{ display: i18n.translation.items.all, url: "/items" }, { display: data?.code ?? "" }]}
      />

      <FlexContent padding>
        <ItemPage variant="page" item={data} />
        <SubmitBar>
          <Button
            buttonProps={{
              onClick: () => navigate(-1),
            }}
          >
            {i18n.translation.common.back}
          </Button>
        </SubmitBar>
      </FlexContent>
    </>
  );
};

export default Item;
